import React, {useEffect, useState} from 'react';
import {XMarkIcon} from '@heroicons/react/24/outline';
import styles from './UpdatePopUp.module.css';
import Button from "../../../components/common/button/Button";
import {getChatBotAPI, updateChatAPI} from "../../../services/admin";

interface UpdateChatBotPopUpProps {
    isOpen: boolean;
    onClose: () => void;
}

//챗봇 최초 출력 문장 수정 팝업
const UpdateChatBotPopUp: React.FC<UpdateChatBotPopUpProps> = ({isOpen, onClose}) => {
    const [chat, setChat] = useState<string>('');
    const [loading, setLoading] = useState(true);

    const handleSubmit = async () => {
        try {
            //챗봇 최초 출력 문장 수정 API
            await updateChatAPI({chat: chat});
        } catch (error) {
            console.error('Error update chatbot request:', error);
        }
        fetchChat();
        onClose();
        window.location.reload();
    };

    const fetchChat = async () => {
        try {
            setLoading(true);
            //챗봇 최초 출력 문장 조회 API
            const response = await getChatBotAPI();
            setChat(response);
        } catch (error) {
            console.error('Error fetching term request:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchChat();
    }, []);

    if (!isOpen) return null;

    if (loading) {
        return <div className={styles.loading}>Loading...</div>;
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2 className={styles.title}>챗봇 첫 출력 문장 작성</h2>
                    {/*챗봇 최초 출력 문장 수정 팝업 닫기 버튼*/}
                    <button onClick={onClose} className={styles.closeButton}>
                        <XMarkIcon className={styles.closeIcon}/>
                    </button>
                </div>
                <div className={styles.content}>
                    <div className={styles.formGroup}>
                        <label>챗봇 첫 출력 문장</label>
                        {/*챗봇 최초 출력 문장 입력창*/}
                        <textarea
                            value={chat}
                            onChange={(e) => setChat(e.target.value)}
                            placeholder="챗봇 첫 출력 문장을 적어주세요"
                            className={styles.textarea}
                        />
                    </div>
                </div>

                <div className={styles.footer}>
                    {/*저장 버튼*/}
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={!chat?.trim()}
                        className={styles.submitButton}
                    >
                        저장
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default UpdateChatBotPopUp;